/**
 * InfoTooltip — Tooltip com ícone (i) para exibir fórmula/explicação de indicadores
 */
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface InfoTooltipProps {
  label: string;
  formula?: string;
  description?: string;
  className?: string;
}

export default function InfoTooltip({ label, formula, description, className = "" }: InfoTooltipProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button type="button" className={`inline-flex items-center gap-1 text-muted-foreground hover:text-foreground transition-colors ${className}`}>
            <Info size={14} className="shrink-0" />
            <span className="text-xs underline decoration-dotted">{label}</span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {formula && <p className="text-xs font-mono bg-muted/50 px-2 py-1 rounded mb-1">{formula}</p>}
          {description && <p className="text-xs text-muted-foreground">{description}</p>}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
